import useIsWindowGreaterThanWidth from './useIsWindowGreaterThanWidth';

export const TABLET_VIEW_FROM = 960;

function useIsTablet(widthProp = TABLET_VIEW_FROM) {
  return !useIsWindowGreaterThanWidth(widthProp);
}

export default useIsTablet;
